// extracted by mini-css-extract-plugin
export default {"CommitSelectorWrapper":"CommitSelector-module__CommitSelectorWrapper--Wp_n9","CommitSelectorContainer":"CommitSelector-module__CommitSelectorContainer--_atPn"};